<template>
    <div class="container-fluid bsite_bStore_deals card" style="padding-top:0px;">
        <loader v-if="isLoading" class="bgloading"/>
        <div class="card-header">
            <div class="input-title">
                <i class="fa fa-pen" style=""></i>
                <input type="text" v-model="deals_title" class="deals_title" :placeholder="lang.bsdl_title_ph" maxlength="30" @change="editTitle"/>
                <label :for="dealsDaysId" :class="['checkSwitch', 'badge badge-xs', deals_enabled ? 'badge-success' : 'badge-secondary']">
                    <div class="iCheckswitch">
                        <input type="checkbox" :id="dealsDaysId" v-model="deals_enabled" @change="activeDeals"/>
                        <label class="iCheckswitch-label" :for="dealsDaysId">
                            <span class="iCheckswitch-inner"></span>
                        </label>
                    </div>
                    <span class="form-check-label-text" v-if="deals_enabled">{{ lang.bs_on }}</span>
                    <span class="form-check-label-text" v-else>{{ lang.bs_off }}</span>
                </label>
                <!-- <select v-model="deals_lang" class="form-control" style="margin-left: 15px; width: 120px;" @change="changeLang">
                    <option v-for="langOpt in listLanguage" :key="langOpt.value" :value="langOpt.value">{{ langOpt.text }}</option>
                </select> -->
            </div>
            <p>{{ lang.bsdl_exclusive_offers }}</p>
        </div>
        <div class="card-body" style="padding: 10px 0">
            <ul class="nav nav-tabs deals-days" role="tablist">
                <li v-for="d in deals_days" :key="d.id" :class="['nav-item', !deals_enabled ? 'disabled' : '']">
                    <button :class="['nav-link-button', d.day_enabled ? 'active' : '']" @click="showDay(d)" :disabled="!deals_enabled">
                        {{ daysNames[deals_lang][d.id - 1] }}
                    </button>
                    <label :for="d.id" :class="['checkSwitch', 'badge badge-xs', d.day_enabled ? '' : 'badge-secondary']">
                        <div class="iCheckswitch">
                            <input type="checkbox" :id="d.id" v-model="d.day_enabled" @change="statusDay(d)" :disabled="!deals_enabled"/>
                            <label class="iCheckswitch-label" :for="d.id">
                                <span class="iCheckswitch-inner"></span>
                            </label>
                        </div>
                    </label>
                </li>
            </ul>
            <div class="day-body" id="deals-day-body" style="margin-top: 20px;">
                <div v-for="d in deals_days" :key="d.id" v-show="selected_day_id === d.id" class="content-items">

                    <!-- List view -->
                    <div v-if="!editingFor(d.id)" class="deals-section">
                        <div class="editTitleDay">
                            <div class="titleHeader">
                                <label :for="d.id+'-title_day'" :class="['checkSwitch', 'badge badge-xs', d.title_day_enabled ? 'badge-success' : 'badge-secondary']">
                                    <div class="iCheckswitch">
                                        <input type="checkbox" :id="d.id+'-title_day'" v-model="d.title_day_enabled" @change="changeTileDayStatus(d)" :disabled="!deals_enabled"/>
                                        <label class="iCheckswitch-label" :for="d.id+'-title_day'">
                                            <span class="iCheckswitch-inner"></span>
                                        </label>
                                    </div>
                                </label>
                                {{ lang.bsdl_title_section }}
                            </div>
                            <div class="titleinput">
                                <h1 :class="[!d.title_day_enabled ? 'disabled' : '']" v-text="d.title_day" :contenteditable="d.title_day_enabled" @blur="onEditTitleDay(d, $event)" @keyup.enter.prevent @keypress="limitNameDay" @input="validateTitle($event)"></h1>
                            </div>
                        </div>
                        <div class="form-group content-box-editor">
                            <div class="editor-header">
                                <label :for="d.id+'-content_box'" :class="['checkSwitch', 'badge badge-xs', d.content_box_enabled ? 'badge-success' : 'badge-secondary']">
                                    <div class="iCheckswitch">
                                        <input type="checkbox" :id="d.id+'-content_box'" v-model="d.content_box_enabled" @change="changeTileDayStatus(d)" :disabled="!deals_enabled"/>
                                        <label class="iCheckswitch-label" :for="d.id+'-content_box'">
                                            <span class="iCheckswitch-inner"></span>
                                        </label>
                                    </div>
                                </label>
                                {{ lang.bsdl_desc_optional }}
                            </div>
                            <div :class="['content-box-toggle', !d.content_box_enabled ? 'editor-disabled' : '']">
                                <vue-editor :disabled="!d.content_box_enabled" v-model="d.content_box" :editor-toolbar="editorToolbar" placeholder="Enter description..." @blur="onEditContentBox(d)" @ready="onEditorReady"></vue-editor>
                            </div>
                        </div>
                        <draggable v-model="d.items" tag="div" class="deals-list" v-bind="dragOptions" handle=".deal-drag-handle" @start="isDragging=true" @end="isDragging=false">
                            <div class="deal-card" v-for="(item, iIdx) in d.items" :key="item._uid || iIdx">
                                <div class="deal-drag-handle" title="Drag to reorder"><i class="fas fa-grip-lines"></i></div>
                                <div class="deal-card-thumb">
                                    <img v-if="item.image" :src="getImageUrl(item.image)" class="deal-thumb-img" alt="deal" />
                                    <div v-else class="deal-thumb-placeholder">
                                        <i class="fas fa-image"></i>
                                    </div>
                                    <span :class="['deal-status-badge', item.status === 'active' ? 'badge-success' : 'badge-secondary']">
                                        {{ item.status }}
                                    </span>
                                    <button v-if="d.items.length > 1" class="btn-deal-del" @click.prevent="deleteItem(d, iIdx)" title="Delete">
                                        <i class="fas fa-trash-alt"></i>
                                    </button>
                                </div>
                                <div class="deal-card-info">
                                    <div class="deal-card-title">{{ item.title || 'No title' }}</div>
                                    <div class="deal-card-price" v-if="item.price > 0">{{currency}} {{ Number(item.price).toFixed(2) }}</div>
                                </div>
                                <button class="btn-edit-deal" @click.prevent="openEditItem(d, iIdx)" title="Edit">
                                    <i class="fas fa-pen"></i>
                                </button>
                            </div>
                        </draggable>
                        <button class="btn btn-primary btn-sm add-deal-btn" @click.prevent="addItem(d)">
                            <i class="fas fa-plus"></i> {{ lang.bsdl_add_deal }}
                        </button>
                    </div>

                    <!-- Edit / Add form -->
                    <div v-else class="deal-form-panel">
                        <div class="deal-form-header">
                            <h6>{{ editingItemIdx === null ? lang.bsdl_new_deal : lang.bsdl_edit_deal }}</h6>
                            <button class="btn btn-sm btn-light" @click.prevent="cancelEdit()">
                                <i class="fas fa-times"></i> {{ lang.bs_cancel }}
                            </button>
                        </div>

                        <div class="deal-form-body">

                            <!-- Title -->
                            <div class="form-group">
                                <label>{{ lang.bs_title_label }}</label>
                                <input type="text" v-model="editingItem.title" class="form-control" :placeholder="lang.bsdl_deal_title_ph" maxlength="100" />
                            </div>

                            <!-- Price -->
                            <div class="form-group">
                                <label>{{ lang.bs_price }}</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">{{currency}}</span>
                                    </div>
                                    <input type="number" v-model.number="editingItem.price" class="form-control" placeholder="0.00" min="0" step="0.01" />
                                </div>
                            </div>

                            <!-- Description -->
                            <div class="form-group">
                                <label>{{ lang.bs_description }}</label>
                                <div class="editor-header">{{ lang.bsdl_optional_label }}</div>
                                <vue-editor v-model="editingItem.description" :editor-toolbar="editorToolbar" @ready="onEditorReady"></vue-editor>
                            </div>

                            <!-- Status -->
                            <div class="form-group deal-form-status">
                                <label>{{ lang.bs_status }}</label>
                                <label :for="'deal-status-' + editingItemUID" :class="['checkSwitch', 'badge badge-xs', editingItem.status === 'active' ? 'badge-success' : 'badge-secondary']">
                                    <div class="iCheckswitch">
                                        <input type="checkbox" :id="'deal-status-' + editingItemUID" :checked="editingItem.status === 'active'" @change="toggleStatus" />
                                        <label class="iCheckswitch-label" :for="'deal-status-' + editingItemUID">
                                            <span class="iCheckswitch-inner"></span>
                                        </label>
                                    </div>
                                    <span class="form-check-label-text">{{ editingItem.status === 'active' ? lang.bs_active : lang.bs_inactive }}</span>
                                </label>
                            </div>
                            <!-- Image -->
                            <div class="deal-form-image">
                                <div v-if="editingItem.image" class="image-preview-wrap">
                                    <img :src="getImageUrl(editingItem.image)" class="image-preview" alt="preview" />
                                    <div class="image-preview-actions">
                                        <button class="btn-img-action" @click.prevent="triggerImageInput()" title="Change image">
                                            <i class="fas fa-camera"></i>
                                        </button>
                                        <button class="btn-img-action btn-img-remove" @click.prevent="editingItem.image = null; file_image = null" title="Remove image">
                                            <i class="fas fa-times"></i>
                                        </button>
                                    </div>
                                </div>
                                <div v-else class="image-upload-placeholder" @click.prevent="triggerImageInput()">
                                    <i class="fas fa-cloud-upload-alt"></i>
                                    <span>{{ lang.bsdl_upload_image }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="deal-form-actions">
                            <button class="btn btn-primary" @click.prevent="saveItem(d)">
                                <i class="fas fa-save"></i> {{ lang.bs_save }}
                            </button>
                            <button class="btn btn-light" @click.prevent="cancelEdit()">{{ lang.bs_cancel }}</button>
                        </div>
                    </div>
                    <input type="file" ref="dealImage" accept="image/jpeg,image/jpg,image/png,image/webp" style="display:none" @change="onImageChange" />
                </div>
                <div v-if="!deals_enabled" class="deals-disabled-overlay">
                    <div class="deals-disabled-message alert alert-secondary">
                        <h2> <i class="fas fa-info-circle"></i> {{ lang.bsdl_enable_message }}</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { VueEditor } from 'vue2-editor';
import draggable from 'vuedraggable';
// @ts-ignore
import loader from '@/core/components/shared/Loader.vue';
export default {
    name: 'bsite_bStore_deals',
    components: { VueEditor, draggable, loader },
    data() {
        return {
            lang: {
                bsdl_title_ph: '',
                bs_on: '',
                bs_off: '',
                bsdl_exclusive_offers: '',
                bsdl_title_section: '',
                bsdl_desc_optional: '',
                bsdl_add_deal: '',
                bsdl_new_deal: '',
                bsdl_edit_deal: '',
                bs_cancel: '',
                bs_title_label: '',
                bs_price: '',
                bs_description: '',
                bsdl_optional_label: '',
                bs_status: '',
                bs_active: '',
                bs_inactive: '',
                bsdl_upload_image: '',
                bs_save: '',
                bsdl_enable_message: '',
                bsdl_deal_title_ph: '',
                bs_error: '',
                bsdl_title_required: '',
                bsdl_failed_save_title: '',
                bsdl_failed_save_content: '',
                bsdl_failed_save_deal: '',
                bsdl_delete_deal: '',
                bs_swal_text: '',
                bs_swal_confirm: '',
                bsdl_failed_delete_deal: '',
                bsdl_failed_save_deals: '',
                bsdl_today_deals: '',
            },
            isLoading: false,
            isDragging: false,
            listLanguage: [
                {value: 'en', text: 'English'},
                {value: 'es', text: 'Spanish'},
            ],
            deals_lang: 'en',
            deals_title: '',
            deals_enabled: false,
            dealsDaysId: "dealsDays_" + Math.random().toString(36).slice(2, 9),
            deals_days: [
                { id: 1, day: "monday", day_enabled: false, title_day_enabled: false, title_day: "", content_box_enabled: false, content_box: "", items: [{ title: "", price: 0, description: "", image: null, status: "active" }] },
                { id: 2, day: "tuesday", day_enabled: false, title_day_enabled: false, title_day: "", content_box_enabled: false, content_box: "", items: [{ title: "", price: 0, description: "", image: null, status: "active" }] },
                { id: 3, day: "wednesday", day_enabled: false, title_day_enabled: false, title_day: "", content_box_enabled: false, content_box: "", items: [{ title: "", price: 0, description: "", image: null, status: "active" }] },
                { id: 4, day: "thursday", day_enabled: false, title_day_enabled: false, title_day: "", content_box_enabled: false, content_box: "", items: [{ title: "", price: 0, description: "", image: null, status: "active" }] },
                { id: 5, day: "friday", day_enabled: false, title_day_enabled: false, title_day: "", content_box_enabled: false, content_box: "", items: [{ title: "", price: 0, description: "", image: null, status: "active" }] },
                { id: 6, day: "saturday", day_enabled: false, title_day_enabled: false, title_day: "", content_box_enabled: false, content_box: "", items: [{ title: "", price: 0, description: "", image: null, status: "active" }] },
                { id: 7, day: "sunday", day_enabled: false, title_day_enabled: false, title_day: "", content_box_enabled: false, content_box: "", items: [{ title: "", price: 0, description: "", image: null, status: "active" }] },
            ],
            daysNames: {
                en: ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
                es: ["lunes", "martes", "miércoles", "jueves", "viernes", "sábado", "domingo"],
            },
            selected_day_id: null,
            maxLength: 10,
            editingDayId: null,
            editingItemIdx: null,
            editingItemUID: null,
            editingItem: null,
            editorToolbar: [
                ['bold', 'italic', 'underline', { color: [] }],
                ['clean'],
            ],
            apis: null,
            currency: '$',
            pusher_id: (typeof pusher !== 'undefined' && pusher && pusher.connection)? pusher.connection.socket_id : null,
            url_image: null,
            file_image: null,
        };
    },
    created() {
        this.lang = this.$store.getters['ModApps/Marketea/lang'];
        this.deals_lang = this.$store.getters['ModApps/Marketea/get_langUpdate'];
        // prepare API routes used to fetch products if store is empty
        try{
            let urlApis = this.$store.getters['ModApps/Marketea/urlApis'];
            this.apis = urlApis.bStore;
        }catch(e){
            this.apis = null;
        }
    },
    mounted(){
        // assign unique IDs to items for tracking in v-for and ensure image is null if it's an array (invalid)
        this.deals_days.forEach(day => {
            day.items.forEach(item => {
                if (!item._uid) item._uid = this.genUID();
                if (Array.isArray(item.image)) item.image = null;
            });
        });
        this.get_currency();
        this.getDeals();
    },
    computed: {
        ...mapGetters("ModApps/Marketea", {
            langGetter: "lang",
            langUpdate: "get_langUpdate",
        }),
        dragOptions() {
            return { animation: 200, group: 'deals', ghostClass: 'deal-card-ghost' };
        },
    },
    watch: {
        langGetter() {
            this.lang = this.$store.getters['ModApps/Marketea/lang'];
        },
    },
    methods: {
        getImageUrl(image) {
            if (!image) return '';
            if (typeof image === 'string' && image.startsWith('data:')) return image;
            return this.url_image ? this.url_image + '/' + image : image;
        },
        genUID() {
            return 'uid_' + Math.random().toString(36).slice(2, 9);
        },
        onEditorReady(quill) {
            const root = quill.root;
            root.addEventListener('paste', (e) => {
                const cd = e.clipboardData;
                if (!cd) return;
                const files = Array.from(cd.files || []);
                const items = Array.from(cd.items || []);
                const hasImage = files.some(f => f.type.startsWith('image/')) || items.some(i => i.type.startsWith('image/'));
                if (hasImage) { e.preventDefault(); e.stopPropagation(); } // Impedir pegar imágenes, permitir solo texto.
            }, true);
            root.addEventListener('drop', (e) => {
                const dt = e.dataTransfer;
                if (!dt) return;
                const files = Array.from(dt.files || []);
                if (files.some(f => f.type.startsWith('image/'))) {
                    e.preventDefault(); e.stopPropagation();
                }
            }, true);
            // Al pegar: elimina estilos inline (color, fondo, fuente…) y de bloque (alineación, indent…),
            // conservando solo bold / italic / underline
            quill.clipboard.addMatcher(Node.ELEMENT_NODE, (_node, delta) => {
                delta.ops = delta.ops.map(op => {
                    if (!op.insert || typeof op.insert !== 'string') return op;
                    // '\n' lleva atributos de bloque (align, indent, direction…) — eliminarlos todos
                    if (op.insert === '\n') return { insert: '\n' };
                    const allowed = {};
                    if (op.attributes) {
                        if (op.attributes.bold) allowed.bold = true;
                        if (op.attributes.italic) allowed.italic = true;
                        if (op.attributes.underline) allowed.underline = true;
                    }
                    return Object.keys(allowed).length ? { insert: op.insert, attributes: allowed } : { insert: op.insert };
                });
                return delta;
            });
        },
        activeDeals() {
            // al activar el deals Today's deals se activaran los dias Lunes a sabado por defecto, el domingo quedara inactivo
            if (this.deals_enabled) {
                this.deals_days.forEach(day => {
                    day.day_enabled = day.id !== 7; // Activa todos excepto domingo
                    // console.log(`Day ${day.day} enabled:`, day.day_enabled);
                    this.$set(day, 'items', day.items); // Asegura reactividad en items al cambiar day_enabled
                });
            } else {
                this.deals_days.forEach(day => {
                    day.day_enabled = false; // Desactiva todos
                    this.$set(day, 'items', day.items); // Asegura reactividad en items al cambiar day_enabled
                });
                console.log("Today's Deals deactivated, all days disabled.", this.deals_days);
            }
            // mostrar primer dia activo o ninguno si se desactiva
            const firstActiveDay = this.deals_days.find(d => d.day_enabled);
            if(firstActiveDay && firstActiveDay.id){
                this.showDay(firstActiveDay);
            }
            this.setDeals(); // Guarda cambios al desactivar para mantener estado consistente
        },
        editTitle() {
            // Limita el título a maxLength caracteres
            if (this.deals_title.length > this.maxLength) {
                this.deals_title = this.deals_title.slice(0, this.maxLength); // Trunca el título si excede el límite
            }
            this.setDeals();
        },
        changeLang() {
            this.isLoading = true;
            this.setDeals();
        },
        showDay(day) {
            this.selected_day_id = day.id;
            this.cancelEdit();
        },
        statusDay(day) {
            console.log("Day status changed:", day);
        },
        validateTitle(e) {
            let t = this;
            const newTitle = e.target.innerText.trim();
            if(newTitle.length && newTitle.length == 0){
                console.log('Title must be at least 3 characters.');
                t.$store.commit('core/setNotiPush', {
                    group: 'notiPush',
                    type: 5, // 1=success | 2=info | 3=error | 4=loading | 5=warning
                    title: t.lang.bs_error,
                    text: t.lang.bsdl_title_required,
                    show: true,
                    duration: 10000
                });
                // no dejar borrar mas de 3 caracteres del título, restaurar al título anterior
                if (text.length >= this.maxLength && e.key !== 'Backspace' && e.key !== 'Delete') {
                    e.preventDefault();
                }
            }
        },
        onEditTitleDay(d, event) {
            let t = this;
            if (!t.apis || !t.apis.set || !t.apis.set(19)) return console.error("API routes not defined for bStore module.");
            const previousTitle = d.title_day;
            const newTitle = event.target.innerText.trim();
            if(newTitle.length < 3){
                console.log('Title must be at least 3 characters.', newTitle);
                event.target.innerText = previousTitle;
                return;
            }
            t.editDealsTitleDay(d, newTitle);
        },
        changeTileDayStatus(d) {
            let t = this;
            t.editDealsTitleDay(d, d.title_day);
        },
        editDealsTitleDay(d, newTitle) {
            let t = this;
            const formData = {
                user_id: window.master_client,
                org_id: window.localorgdata,
                pusher_id: t.pusher_id,
                day_id: d.id,
                title_day: newTitle,
                title_day_enabled: d.title_day_enabled,
            };
            let urlService = t.apis.set(19); // editDealsTitleDay
            window.master.post(urlService, formData)
            .then((response) => {
                console.log(urlService, response.data);
                d.title_day = newTitle; // Actualiza el título solo si la respuesta del servidor es exitosa
            })
            .catch((error) => {
                console.log(error);
                d.title_day = previousTitle;
                t.$swal({ title: t.lang.bs_error, text: t.lang.bsdl_failed_save_title, icon: "error" });
            });
        },
        onEditContentBox(d) {
            let t = this;
            if (!t.apis || !t.apis.set || !t.apis.set(15)) return console.error("API routes not defined for bStore module.");
            const previousContent = d.content_box;
            const formData = {
                user_id: window.master_client,
                org_id: window.localorgdata,
                pusher_id: t.pusher_id,
                day_id: d.id,
                content_box: d.content_box,
                content_box_enabled: d.content_box_enabled,
            };
            let urlService = t.apis.set(15); // editDealsDayContentBox
            window.master.post(urlService, formData)
            .then((response) => {
                console.log(urlService, response.data);
            })
            .catch((error) => {
                console.log(error);
                d.content_box = previousContent;
                t.$swal({ title: t.lang.bs_error, text: t.lang.bsdl_failed_save_content, icon: "error" });
            });
        },
        limitNameDay(e) {
            const text = e.target.innerText;
            if (text.length >= this.maxLength && e.key !== 'Backspace' && e.key !== 'Delete') {
                e.preventDefault();
            }
        },
        triggerImageInput() {
            const r = this.$refs.dealImage;
            const el = Array.isArray(r) ? r[0] : r;
            if (el instanceof HTMLInputElement) el.click();
        },
        editingFor(dayId) {
            return this.editingDayId === dayId && this.editingItem !== null;
        },
        openEditItem(day, itemIdx) {
            this.editingDayId = day.id;
            this.editingItemIdx = itemIdx;
            this.editingItemUID = this.genUID();
            this.editingItem = { ...day.items[itemIdx] };
            console.log("Editing item:", this.editingItem, day);
        },
        addItem(day) {
            this.editingDayId = day.id;
            this.editingItemIdx = null;
            this.editingItemUID = this.genUID();
            this.editingItem = { _uid: this.genUID(), title: '', price: 0, description: '', image: null, status: 'active' };
        },
        cancelEdit() {
            this.editingDayId = null;
            this.editingItemIdx = null;
            this.editingItemUID = null;
            this.editingItem = null;
            this.file_image = null;
        },
        saveItem(day) {
            const savedItem = { ...this.editingItem };
            const savedIdx = this.editingItemIdx;
            // snapshot del ítem original para restaurar si falla el servidor
            const originalItem = savedIdx !== null ? { ...day.items[savedIdx] } : null;

            if (savedIdx === null) {
                day.items.push(savedItem);
            } else {
                this.$set(day.items, savedIdx, savedItem);
            }

            let t = this;
            if (!t.apis || !t.apis.set || !t.apis.set(17)) return console.error("API routes not defined for bStore module.");
            t.isLoading = true;

            const imageChanged = savedIdx !== null && typeof savedItem.image === 'string' && savedItem.image.startsWith('data:');
            const imageRemoved = savedIdx !== null && savedItem.image === null && savedItem.previous_image;
            /**
             * parametros para agregar o editar items de cada dia de today deals
             * user_id
             * org_id
             * day_id
             * item_id (opcional, si se envia se edita el item, si no se envia se agrega un nuevo item)
             * item_title
             * item_price
             * item_description
             * item_status (active o inactive)
             * item_image (archivo de imagen, opcional, si se envia se sube la imagen y se asigna al item, si no se envia no se modifica la imagen del item)
             * previous_image (archivo de imagen, opcional, solo se envia en edición cuando se reemplaza la imagen, se utiliza para eliminar la imagen anterior del servidor luego de subir la nueva imagen)
             */
            const formData = new FormData();
            formData.append('user_id', window.master_client);
            formData.append('org_id', window.localorgdata);
            formData.append('pusher_id', t.pusher_id);
            formData.append('day_id', day.id);
            formData.append('item_id', savedIdx !== null ? day.items[savedIdx].id || '' : '');
            formData.append('item_title', savedItem.title);
            formData.append('item_price', savedItem.price);
            formData.append('item_description', savedItem.description);
            formData.append('item_status', savedItem.status);
            if (t.file_image) {
                formData.append('item_image', t.file_image, t.file_image.name);
                if (imageChanged && savedItem.previous_image) {
                    formData.append('previous_image', savedItem.previous_image);
                }
            } else if (imageRemoved) {
                formData.append('remove_image', '1');
                formData.append('previous_image', savedItem.previous_image);
            }
            let urlService = t.apis.set(17); // setDealsDayItems
            console.log(urlService, [...formData.entries()]);
            window.master.post(urlService, formData, {
                headers: { "Content-Type": "multipart/form-data" }
            })
            .then((response) => {
                console.log(urlService, response.data);
                t.isLoading = false;
                if (response.data.status && response.data.items) {
                    const dayRef = t.deals_days.find(d => d.id === day.id);
                    if (dayRef) {
                        // snapshot de imágenes actuales antes de sobreescribir, por si el servidor no las devuelve
                        const prevImages = {};
                        dayRef.items.forEach(item => {
                            if (item.id && item.image && !item.image.startsWith('data:')) {
                                prevImages[item.id] = item.image;
                            }
                        });
                        dayRef.items = response.data.items.map(i => {
                            const img = i.image || prevImages[i.id] || null;
                            return { ...i, image: img, _uid: i._uid || t.genUID(), previous_image: img };
                        });
                    }
                }
                t.cancelEdit();
            })
            .catch((error) => {
                console.log(error);
                t.isLoading = false;
                if (savedIdx === null) {
                    day.items.pop();
                } else if (originalItem) {
                    t.$set(day.items, savedIdx, originalItem);
                }
                t.cancelEdit();
                t.$swal({ title: t.lang.bs_error, text: t.lang.bsdl_failed_save_deal, icon: "error" });
            });
        },
        deleteItem(day, itemIdx) {
            if (day.items.length <= 1) return;
            let t = this;
            this.$swal({
                title: t.lang.bsdl_delete_deal,
                text: t.lang.bs_swal_text,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: t.lang.bs_swal_confirm,
            }).then((result) => {
                if (!result.value) return;
                const item = day.items[itemIdx];
                if (!item.id) {
                    day.items.splice(itemIdx, 1);
                    return;
                }
                if (!t.apis || !t.apis.set || !t.apis.set(18)) return console.error("API routes not defined for bStore module.");
                t.isLoading = true;
                const formData = {
                    user_id: window.master_client,
                    org_id: window.localorgdata,
                    pusher_id: t.pusher_id,
                    day_id: day.id,
                    item_id: item.id,
                };
                let urlService = t.apis.set(18); // delDealsDayItems
                window.master.post(urlService, formData)
                .then((response) => {
                    console.log(urlService, response.data);
                    t.isLoading = false;
                    day.items.splice(itemIdx, 1);
                })
                .catch((error) => {
                    console.log(error);
                    t.isLoading = false;
                    t.$swal({ title: t.lang.bs_error, text: t.lang.bsdl_failed_delete_deal, icon: "error" });
                });
            });
        },
        onImageChange(e) {
            const file = e.target.files[0];
            if (!file) return;
            this.file_image = file;
            const reader = new FileReader();
            reader.onload = (evt) => {
                this.editingItem = { ...this.editingItem, image: evt.target.result, file: file };
            };
            reader.readAsDataURL(file);
            const r = this.$refs.dealImage;
            const el = Array.isArray(r) ? r[0] : r;
            if (el instanceof HTMLInputElement) el.value = '';
        },
        toggleStatus() {
            this.editingItem.status = this.editingItem.status === 'active' ? 'inactive' : 'active';
        },
        get_currency(){
            let t = this;
            let formData = {};
            formData.user_id = window.master_client;
            formData.org_id = window.localorgdata;
            formData.pusher_id = this.pusher_id;
            if(!t.apis || !t.apis.get || !t.apis.get(4)) return console.error("API routes not defined for bStore module.");
            let urlService = t.apis.get(4)// get_currency
            window.master.post(urlService, formData)
            .then((response) => {
                console.log(urlService, response.data);
                if (response.data.status && response.data.currency && response.data.currency.meta_value) {
                    t.$store.commit('ModApps/Marketea/set_bStore_currency', response.data.currency.meta_value);
                    t.currency = response.data.currency.meta_value;
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        getDeals(refresh){
            let t = this;
            let formData = {};
            formData.user_id = window.master_client;
            formData.org_id = window.localorgdata;
            formData.pusher_id = this.pusher_id;
            if(!t.apis || !t.apis.get || !t.apis.get(5)) return console.error("API routes not defined for bStore module.");
            let urlService = t.apis.get(5)// getDeals
            t.isLoading = refresh === undefined ? true : false;
            window.master.post(urlService, formData)
            .then((response) => {
                console.log(urlService, response.data);
                t.isLoading = false;
                if (response.data.status && response.data.deals) {
                    this.url_image = response.data.url_image || null;
                    let dealsData = response.data.deals;
                    t.deals_lang = dealsData.lang || 'en';
                    t.deals_title = dealsData.title || this.lang.bsdl_today_deals;
                    t.deals_enabled = (dealsData.enabled == 1);
                    t.deals_days = dealsData.days.map(d => ({
                        id: d.id,
                        day: d.day,
                        day_enabled: d.day_enabled || false,
                        title_day_enabled: d.title_day_enabled || false,
                        title_day: d.title_day || '',
                        content_box_enabled: d.content_box_enabled || false,
                        content_box: d.content_box || '',
                        items: d.items.map(item => ({
                            title: item.title || '',
                            price: item.price || 0,
                            description: item.description || '',
                            image: item.image || null,
                            previous_image: item.image || null,
                            status: item.status || 'active',
                            id: item.id || null,
                            _uid: this.genUID(),
                        })) || [],
                    })) || [];
                    // mostrar primer dia activo o ninguno si se desactiva
                    const firstActiveDay = t.deals_days.find(d => d.day_enabled);
                    if(firstActiveDay && firstActiveDay.id){
                        this.showDay(firstActiveDay);
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                t.isLoading = false;
            });
        },
        setDeals() {
            let t = this;
            t.isLoading = true;
            let formData = {};
            formData.user_id = window.master_client;
            formData.org_id = window.localorgdata;
            formData.pusher_id = this.pusher_id;
            formData.title = t.deals_title;
            formData.deals_lang = t.deals_lang;
            formData.deals_enabled = t.deals_enabled ? 1 : 0;
            formData.days = t.deals_days.map(d => ({
                id: d.id,
                day: d.day,
                day_enabled: d.day_enabled,
                content_box: d.content_box,
                items: d.items.map(item => ({
                    title: item.title,
                    price: item.price,
                    description: item.description,
                    image: item.image,
                    status: item.status,
                })),
            }));
            if(!t.apis || !t.apis.set || !t.apis.set(14)) return console.error("API routes not defined for bStore module.");
            let urlService = t.apis.set(14)// setDeals
            console.log("Saving deals with data:", formData, urlService);
            window.master.post(urlService, formData)
            .then((response) => {
                console.log(urlService, response.data);
                t.isLoading = false;
                let dealsData = response.data.q || null;
                if(!dealsData) return;
                t.deals_lang = dealsData.lang || 'en';
                t.deals_title = dealsData.title || this.lang.bsdl_today_deals;
                t.deals_enabled = (dealsData.enabled == 1);
                t.deals_days = dealsData.days.map(d => ({
                    id: d.id,
                    day: d.day,
                    day_enabled: d.day_enabled || false,
                    title_day_enabled: d.title_day_enabled || false,
                    title_day: d.title_day || '',
                    content_box_enabled: d.content_box_enabled || false,
                    content_box: d.content_box || '',
                    items: d.items.map(item => ({
                        title: item.title || '',
                        price: item.price || 0,
                        description: item.description || '',
                        image: item.image || null,
                        previous_image: item.image || null,
                        status: item.status || 'active',
                        id: item.id || null,
                        _uid: this.genUID(),
                    })) || [],
                })) || [];
            })
            .catch((error) => {
                console.log(error);
                t.isLoading = false;
                t.$swal({ title: t.lang.bs_error, text: t.lang.bsdl_failed_save_deals, icon: "error" });
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.input-title {
    position: relative;
    i {
        color: #888;
        font-size: 18px;
        pointer-events: none;
        position: absolute;
        top: 0;
    }
    display: flex;
    align-items: center;
}
input.deals_title {
    font-size: 30px;
    font-weight: bold;
    margin-bottom: 0px;
    width: 100%;
    max-width: 600px;
    padding: 10px;
    border: 0px;
    box-shadow: none;
    background: transparent;
    :hover, :focus {
        outline: none;
        border: 0px;
        box-shadow: none;
    }
}
.deals-days {
    display: flex;
    gap: 0px 10px;
    flex-direction: row;
    flex-wrap: nowrap;
    width: 100%;
    height: 55px;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar { display: none; }
    &::-webkit-scrollbar { height: 6px; }
    &::-webkit-scrollbar-thumb { background-color: rgba(0,0,0,.2); border-radius: 3px; }
    &::-webkit-scrollbar-thumb:hover { background-color: rgba(0,0,0,.4); }
    .nav-item {
        display: flex;
        align-items: center;
        gap: 5px;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        border: 1px solid #ddd;
        &.disabled {
            opacity: 0.5;
            .nav-link-button { cursor: not-allowed; }
            .checkSwitch { cursor: not-allowed; }
        }
        .nav-link-button {
            border: none;
            background: none;
            padding: 10px 15px;
            min-width: 90px;
            width: auto;
            max-width: 130px;
            font-size: 20px;
            text-transform: capitalize;
            display: flex;
            align-items: center;
            border: 0px;
            box-shadow: none;
            &:focus { outline: none; box-shadow: none; }
            cursor: pointer;
            &.active { font-weight: bold; }
        }
        .checkSwitch {
            padding: 2px;
            border-radius: 20px;
            margin-right: 10px;
            .iCheckswitch { margin-right: 0px; }
            .iCheckswitch .iCheckswitch-label { width: 35px; }
            .iCheckswitch input[type=checkbox]:checked + .iCheckswitch-label .iCheckswitch-inner {
                transform: translateX(10px);
            }
        }
    }
}

/* ---- Deals section ---- */
.deals-section {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 50%;
}

.deals-list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
}

.deal-card-ghost {
    opacity: 0.4;
    background: #e8f0fe;
    border: 2px dashed #0d6efd;
}

.deal-card {
    position: relative;
    width: 300px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0,0,0,.08);
    display: flex;
    flex-direction: column;

    .deal-drag-handle {
        width: 100%;
        height: 22px;
        background: #f0f0f0;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: grab;
        color: #aaa;
        font-size: 0.75rem;
        flex-shrink: 0;
        &:active { cursor: grabbing; }
        &:hover { background: #e4e9ff; color: #0d6efd; }
    }

    .deal-card-thumb {
        position: relative;
        width: 100%;
        height: 210px;
        background: #f5f5f5;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        .deal-thumb-img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
        .deal-thumb-placeholder {
            display: flex;
            flex-direction: column;
            align-items: center;
            color: #ccc;
            i { font-size: 3rem; }
        }
        .deal-status-badge {
            position: absolute;
            top: 6px;
            left: 6px;
            font-size: 0.65rem;
            padding: 2px 6px;
            border-radius: 10px;
            color: #fff;
            font-weight: 600;
            text-transform: capitalize;
            &.badge-success { background: #28a745; }
            &.badge-secondary { background: #6c757d; }
        }
        .btn-deal-del {
            position: absolute;
            bottom: 6px;
            right: 6px;
            border: 0;
            border-radius: 4px;
            background: rgba(220,53,69,.85);
            color: #fff;
            width: 26px;
            height: 26px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            font-size: 0.75rem;
            &:hover { background: #dc3545; }
            &:focus { outline: none; }
        }
    }

    .deal-card-info {
        padding: 6px 8px 4px;
        flex: 1;
        .deal-card-title {
            font-size: 1.5rem;
            font-weight: 600;
            color: #333;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .deal-card-price {
            font-size: 0.8rem;
            color: #555;
            margin-top: 2px;
        }
    }

    .btn-edit-deal {
        width: 100%;
        border: 0;
        border-top: 1px solid #eee;
        background: #f8f9fa;
        color: #0d6efd;
        padding: 5px;
        cursor: pointer;
        font-size: 0.78rem;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        &:hover { background: #e9ecef; }
        &:focus { outline: none; }
    }
}

.add-deal-btn {
    align-self: flex-start;
}

/* ---- Form panel ---- */
.deal-form-panel {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background: #fff;
    overflow: hidden;
    max-width: 520px;

    .deal-form-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 16px;
        border-bottom: 1px solid #eee;
        background: #f8f9fa;
        h6 { margin: 0; font-weight: 600; }
    }

    .deal-form-body {
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 14px;

        .form-group {
            margin-bottom: 0;
            label {
                font-size: 0.82rem;
                font-weight: 600;
                color: #555;
                margin-bottom: 4px;
                display: block;
            }
        }
    }

    .deal-form-actions {
        display: flex;
        gap: 10px;
        padding: 12px 16px;
        border-top: 1px solid #eee;
        background: #f8f9fa;
    }
}

/* ---- Image upload / preview ---- */
.deal-form-image {
    .image-upload-placeholder {
        width: 100%;
        height: 140px;
        border: 2px dashed #ccc;
        border-radius: 6px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 8px;
        cursor: pointer;
        color: #aaa;
        transition: border-color .2s, color .2s;
        i { font-size: 2rem; }
        span { font-size: 0.82rem; }
        &:hover { border-color: #0d6efd; color: #0d6efd; }
    }

    .image-preview-wrap {
        position: relative;
        width: 100%;
        height: 160px;
        border-radius: 6px;
        overflow: hidden;
        border: 1px solid #ddd;
        .image-preview {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
        .image-preview-actions {
            position: absolute;
            bottom: 8px;
            right: 8px;
            display: flex;
            gap: 6px;
        }
        .btn-img-action {
            border: 0;
            border-radius: 4px;
            width: 30px;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            font-size: 0.85rem;
            background: rgba(0,0,0,.55);
            color: #fff;
            &:hover { background: rgba(0,0,0,.8); }
            &:focus { outline: none; }
            &.btn-img-remove { background: rgba(220,53,69,.75); &:hover { background: #dc3545; } }
        }
    }
}

/* ---- Vue Editor height ---- */
.deals-section .form-group,
.deal-form-body .form-group {
    ::v-deep .ql-editor {
        min-height: 100px;
        max-height: 100px;
        overflow-y: auto;
    }
}

/* ---- Status row ---- */
.deal-form-status {
    display: flex;
    align-items: center;
    gap: 12px; 
    label.checkSwitch {
        padding: 6px 10px 4px 5px;
        border-radius: 20px;
        display: flex!important;
        align-items: center;
        gap: 0 10px;
        .iCheckswitch { height: 20px; }
    }
}
.editTitleDay {
    display: flex;
    flex-direction: column;
    .titleHeader {
        font-size: 0.85rem;
        color: #555;
        background-color: #f1f1f1;
        margin-top: 0px;
        padding: 0px 0px;
        border: 1px solid #ddd;
        display: flex;
        align-items: center;
        gap: 0;
        justify-content: flex-start;
        .checkSwitch {
            height: 25px;
            margin-top: 4px;
            margin-right: 10px;
            margin-bottom: 0px;
        }
    }
    .titleinput {
        display: flex;
        align-items: center;
        gap: 0;
        justify-content: flex-start;
        border: 1px solid #ddd;
        h1 {
            border: 0px solid #ddd;
            flex: 1;
            margin: 0;
            padding-left: 10px;
            height: 45px;
            font-size: 30px;
            font-weight: bold;
            font-family: sans-serif;
            display: flex;
            align-items: center;
            gap: 0;
            justify-content: flex-start;
        }
        h1.disabled {
            color: #aaa!important;
            pointer-events: none;
            background-color: #f5f5f5!important;
            opacity: 1!important;
        }
    }
}
.content-box-editor {
    display: flex;
    flex-direction: column;
    .editor-header {
        font-size: 0.85rem;
        color: #555;
        background-color: #f1f1f1;
        margin-top: 0px;
        padding: 0px 8px 0px 0px;
        border: 1px solid #ddd;
        border-bottom: 0px;
        display: flex;
        align-items: center;
        gap: 0;
        .checkSwitch {
            height: 25px;
            margin-top: 4px;
            margin-right: 10px;
            margin-bottom: 0px;
        }
    }
    .content-box-toggle {
        display: flex;
        align-items: center;
        gap: 0;
        justify-content: flex-start;
        border: 1px solid #ddd;
        ::v-deep .quillWrapper {
            flex: 1;
        }
        ::v-deep .ql-editor {
            font-size: 14px;
            font-weight: normal;
            font-family: sans-serif;
        }
        &.editor-disabled {
            ::v-deep .quillWrapper {
                opacity: 0.45;
                pointer-events: none;
                cursor: not-allowed;
            }
            ::v-deep .ql-container,
            ::v-deep .ql-toolbar {
                background-color: #f5f5f5;
            }
        }
    }
}
</style>
